import type { RequisiteType } from './api';

interface KgsBankPaymentEligibility {
    orderType?: string | null;
    fiatCurrency?: string | null;
    requisiteType?: RequisiteType | null;
    status: string;
    actionsExpired: boolean;
}

export const isKgsBankPaymentEligible = ({
    orderType,
    fiatCurrency,
    requisiteType,
    status,
    actionsExpired,
}: KgsBankPaymentEligibility): boolean => (
    orderType === 'deposit'
    && fiatCurrency?.trim().toUpperCase() === 'KGS'
    && ['card', 'sbp', 'sbp_kgs'].includes(requisiteType || '')
    && status === 'assigned'
    && !actionsExpired
);
